export enum DownloadStatus {
  Pending,
  Ready
}